import { styled } from "@material-ui/core"
import { useLinked } from "@type-r/react";
import * as React from "react"

export interface DragNDropUploadProps {
    $value
}

export const DragNDropUpload = ({ $file }) => {
    const $isDraggingOver = useLinked(false);

    const preventDefaultAndStopPropagation = e => {
        e.preventDefault();
        e.stopPropagation();
    }

    const onDrop = e => {
        preventDefaultAndStopPropagation(e);

        const file = e.dataTransfer.files ? e.dataTransfer.files[0] : null;
        $file.set(file);

        $isDraggingOver.set(false);
    };

    const onDragOver = e => {
        preventDefaultAndStopPropagation(e);
    }

    const onDragEnter = e => {
        preventDefaultAndStopPropagation(e);

        $isDraggingOver.set(true);
    };

    const onDragLeave = e => {
        preventDefaultAndStopPropagation(e);

        $isDraggingOver.set(false);
    };

    return (
        <DropArea
            onDrop={ onDrop }
            onDragOver={ onDragOver }
            onDragEnter={ onDragEnter }
            onDragLeave={ onDragLeave }
            isDraggingOver={ $isDraggingOver.value }>
            <DropIcon src="../../assets/images/dragNDropUpload.png" alt="Upload" />
        </DropArea>
    )
}

const DropArea = styled(({ isDraggingOver, ...rest }) => <div { ...rest } />)({
    padding: '30px',
    backgroundColor: 'transparent',
    display: 'flex',
    justifyContent: 'center',
    border: (props: any) => {
        return props.isDraggingOver ? '1px solid #57bf90' : '';
    }
});


const DropIcon = styled('img')({
    width: '150px',
    height: '150px',
    pointerEvents: 'none'
});